module.exports = __webpack_public_path__ + "static/img/name.ccbef7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/name.png
// module id = uvqv
// module chunks = 1